import { FieldSchema } from './FieldSchema';

export const PlayerSchema: FieldSchema = {
	type: 'object',
	fields: {
		id: { type: 'number' },
		playerId: { type: 'number' },
		username: { type: 'string' },
		color: { type: 'string' },
		energyColor: { type: 'string' },

		isAdmin: { type: 'boolean' },
		isBot: { type: 'boolean' },

		factories: { type: 'number' },
		batteries: { type: 'number' },

		factoryEnergyArr: { type: 'string[]' },
		batteryEnergyArr: { type: 'string[]' },

		donationCup: { type: 'number' },
		donationCupArr: { type: 'string[]' },

		totalDonation: { type: 'number' },
		carbonReserve: { type: 'number' },
		carbonFootprint: { type: 'number' },

		pr: { type: 'number' },
		prArr: { type: 'string[]' },

		seasonalCards: { type: 'number[]' },
		summitCards: { type: 'number[]' },

		equipment: { type: 'number[]' },

		activeContractsAndAwards: { type: 'number[]' },
		completedContracts: { type: 'number[]' },
		failedContracts: { type: 'number[]' },
		completedAwards: { type: 'number[]' },
		completedContractsAndAwards: { type: 'number[]' },

		modifiers: { type: 'string[]' },
		oneTimeModifiers: { type: 'string[]' },
		usedModifiers: { type: 'string[]' },

		effectsUsedThisSeason: { type: 'string[]' },
		cardIdPlayedThisTurn: { type: 'number[]' },

		factoriesBuiltThisSeason: { type: 'number' },
		factoriesBuiltThisSeasonFromCarbonOnly: { type: 'number' },
		batteriesBuiltThisSeason: { type: 'number' },

		freezingPointStolenPlayerId: { type: 'number' },
		neighborFactoryEnergyColorId: { type: 'number' },

		resolveNextWinterSummitContractOrAward: { type: 'boolean' },
	},
};
